import {
    GameIntroColors,
    GameIntroViewConfig, StampConfig, Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StarStruck} from "../StarStruck";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {StarStruckSlideShowPage} from "./StarStruckSlideShowPage";
import {GameClientConfiguration} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";

export class StarStruckIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };

    stampConfig: StampConfig = {
        volatility: Volatility.MEDIUM
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    public gameClientConfigurationApplied(rules: GameClientConfiguration) {
        if(StarStruck.api.gameClientConfiguration.explicitContentWarning) {
            StarStruck.api.gameClientConfiguration.explicitContentWarning = false;
        }
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("feature1", "resources/images/Intro_Feature_1.png");
        imgLoader.add("feature2", "resources/images/Intro_Feature_2.png");
        imgLoader.add("introLogo", "resources/images/introLogo.png");
        imgLoader.add("introX1000", "resources/images/introX1000.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {

        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();


        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introLogo"));
        logoSprite.name = "logo";
        logoSprite.anchor.set(0.5, 0.5);
        logoSprite.scale.set(0.8);
        this.logo.addChild(logoSprite);
        logoSprite.position.set(0, 0);

        this.pages = [
            new StarStruckSlideShowPage(ImgLoader.getImgTexture("feature1"),[Translation.translate("WIN UP TO")],ImgLoader.getImgTexture("introX1000" ), false),
            new StarStruckSlideShowPage(ImgLoader.getImgTexture("feature2"),["MULTIPLYING", "WILDS"], undefined, true)
        ]

        if (StarStruck.api.gameClientConfiguration.isSet) {
            if (StarStruck.api.gameClientConfiguration.showLowProbabilityGfx === false) {
                (<StarStruckSlideShowPage>this.pages[0]).hideText();
            }
        } else {
            StarStruck.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (StarStruck.api.gameClientConfiguration.showLowProbabilityGfx === false) {
                    (<StarStruckSlideShowPage>this.pages[0]).hideText();
                }
            });
        }
    }

}